export default "__VITE_ASSET__b55ea549__"